module.exports = __webpack_public_path__ + "static/media/git.d72d12db.png";